export enum FollowUpTodo {
  POLICY_HOLDER_TODO = 'policyHolderTodo',
  CREDIT_CARD_TODO = 'creditCardTodo',
  HIGH_ACUITY_TODO = 'highAcuityTodo',
  IDENTIFICATION_CARD_TODO = 'identificationCardTodo',
}

export enum FollowUpCheckboxCase {
  PHONE_CALL = 'phone-call',
  TEXT = 'text',
  EMAIL = 'email',
  VOICE = 'voice',
  INFO_COLLECTED = 'info-collected',
  INFO_NOT_COLLECTED = 'info-not-collected',
  ABLE_TO_SCREEN = 'able-to-screen',
  NOT_ABLE_TO_SCREEN = 'not-able-to-screen',
  CLIENT_APPROPRIATE = 'client-appropriate',
  CLINET_NOT_APPROPRIATE = 'client-not-appropriate',
}

export enum FollowUpTodoArr {
  PHONE = 'PHONE',
  TEXT = 'TEXT',
  EMAIL = 'EMAIL',
  VOICE_EMAIL = 'VOICE_EMAIL',
}
